<template>
  <div class="root-stats">
    <div class="tabk">
      <button
        v-for="tab in setTabs"
        :key="tab.id"
        :class="{ active: selectedSetTab === tab.alias }"
        @click="selectedSetTab = tab.alias"
      >
        {{ tab.name }}
      </button>
    </div>

    <deposit-goal-panel
      v-if="selectedSetTab === 'DEP_GOAL'"
    ></deposit-goal-panel>
    <add-edit-brokers-container
      v-if="selectedSetTab === 'BRK_MNG'"
    ></add-edit-brokers-container>
    <add-edit-users-container
      v-if="selectedSetTab === 'USR_MNG'"
    ></add-edit-users-container>
    <games-permissions-container
      v-if="selectedSetTab === 'GAM_PERM'"
    ></games-permissions-container>
    <system-log v-if="selectedSetTab === 'SYSTEM_LOG'"></system-log>
  </div>
</template>

<script>
import DepositGoalPanel from "../components/DepositGoalPanel";
import AddEditUsersContainer from "./AddEditUsersContainer";
import AddEditBrokersContainer from "./AddEditBrokersContainer";
import GamesPermissionsContainer from "../games.settings/containers/GamesPermissions.container";
import SystemLog from "../components/SystemLog";

export default {
  name: "Settings.container",
  components: {
    SystemLog,
    AddEditBrokersContainer,
    AddEditUsersContainer,
    DepositGoalPanel,
    GamesPermissionsContainer
  },
  data() {
    return {
      showDepGoalPanel: false,
      selectedSetTab: "DEP_GOAL",
      setTabs: [
        {
          id: 0,
          name: "User Managing",
          alias: "USR_MNG"
        },
        {
          id: 1,
          name: "Broker Managing",
          alias: "BRK_MNG"
        },
        {
          id: 2,
          name: "Dep Goal Set",
          alias: "DEP_GOAL"
        },
        {
          id: 3,
          name: "Games Permissions",
          alias: "GAM_PERM"
        },
        {
          id: 4,
          name: "System Log﻿﻿﻿",
          alias: "SYSTEM_LOG"
        }
      ]
    };
  },

  watch: {
    selectedSetTab: function() {
      if (this.selectedSetTab === "MSG_STATS") {
      }
      if (this.selectedSetTab === "REPORTS") {
      }
      if (this.selectedSetTab === "GAM_PERM") {
      }
      if (this.selectedSetTab === "SYSTEM_LOG") {
      }
    }
  }
};
</script>

<style scoped>
.root-stats {
  height: 100%;
}

.tabk {
  float: left;
  background-color: #f1f1f1;
  height: 100%;
}

.tabk button {
  display: block;
  font-size: 8pt;
  background-color: inherit;
  color: black;
  padding: 22px 16px;
  width: 100%;
  height: 30px;
  border: none;
  outline: none;
  text-align: left;
  cursor: pointer;
  transition: 0.2s;
  line-height: 8pt;
}

.tabk button.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  width: 107%;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.tabk button:hover {
  background: #44a2d2;
  color: white;
  width: 107%;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.tabk span {
  font-size: 8pt;
  font-weight: normal;
}
</style>
